import { getCookie } from '../../Cookies'

const Cookie = getCookie('authorization')

export const AuthorizationHeader = {
  'authorization': Cookie,
  'Content-Type': 'application/json',
}
